import { Box, Button, Dialog, DialogActions, DialogContent, Divider, Grid, IconButton, Skeleton, Theme, Typography } from '@mui/material';
import { MFSubmitButton, MFTextField } from '../../lib/formik';
import { Formik, useFormikContext } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import {
  Distributor,
  getLocationList,
  getRMsList,
  SubDistributor,
} from '../../redux-store/actions';
import React, { useEffect, useState } from 'react';
import { RootStateType } from '../../redux-store/reducers';
import { updateApplication } from '../../redux-store/actions/application';
import { useHistory, useRouteMatch } from 'react-router';
import { AMC_APPROVER_CHECK_FOR_INDIVIDUAL, PHYSICAL_DIGITAL_FLOW, ROLE_TYPE, USER_ROLES } from '../../utils/constant';
import { ProceedSaveLater } from './components';
import {
  applicationComparison,
  applyRoleBasedStatus,
  saveForLater,
} from '../../utils/utilityFunctions';
import { RMType, SupportRmProp } from '../../redux-store/types/api-types';
import { SearchableSelect } from '../../lib/formik/searchSelectField';
import { distributorsValidationSchema } from '../../utils/schema';
import MFSelectField from '../../lib/formik/SelectField';
import { LocationType, mdmsLocationList } from '../../redux-store/types/mdms';
import { showError } from '../../redux-store/actions/auth';
import { getRMById, getRMByIwappRmId } from '../../redux-store/actions/userManagement';
import { CountryCodesDropDown } from '../commonComponents';
import MFCheckbox from '../../lib/formik/Checkbox';

type DistributorDetailsProps = {
  firstName: string;
  phone: any;
  email: string;
  saveType: string;
  rm_id: number | null | undefined;
  location: string | null;
  isBSEEnabled?: boolean;
  isEsignEnabled?: boolean;
  currentRM?: any;
};

function GridItem({ children }: { children: React.ReactNode }) {
  return (
    <Grid item xs={12} lg={6}>
      {children}
    </Grid>
  );
}

const RMDetail = ({
  isSupportRM,
  rmsList,
  values,
  locationMaster,
}: {
  isSupportRM: boolean;
  rmsList: any;
  values: any;
  locationMaster: mdmsLocationList[];
}) => {
  const [mobileElementWidth, setMobileElementWidth] = useState(null);

  useEffect(() => {
    const mobileElement = document.getElementsByName('phone');
    setMobileElementWidth(mobileElement[0]?.parentElement?.clientWidth as any);
  }, []);

  const rmsListSorting = [...rmsList].sort((a, b) => (a.name > b.name ? 1 : -1));
  const selectedRm = rmsList.find((item: SupportRmProp) => item.id === values.rm_id);

  return (
    <>
      <GridItem>
        <MFTextField
          name="firstName"
          label={isSupportRM ? "Service RM's Name" : "RM's Name"}
          placeholder="Enter RM name"
          disabled={true}
          value={values.firstName ?? ""}
        />
      </GridItem>
      <GridItem>
        <MFTextField
          name="email"
          label={isSupportRM ? "Service RM's Email Address" : "RM's Email Address"}
          placeholder="Enter RM Email ID"
          disabled={true}
          value={values.email ?? ""}
        />
      </GridItem>
      <GridItem>
        <MFTextField
          name="phone"
          label={isSupportRM ? "Service RM's Mobile Number" : "RM's Mobile Number"}
          placeholder="Enter Mobile Number"
          disabled={true}
          value={values?.phone?.split(" ")?.[1] ?? ""}
          startAdornment={
            <CountryCodesDropDown
              ElementWidth={mobileElementWidth && mobileElementWidth}
              name="phone"
              value={values?.phone?.split(" ")?.[0] ?? ""}
              disabled={true}
            />
          }
        />
      </GridItem>
      <GridItem>
        {/* <MFSelectField
          name={`location`}
          label={'Location'}
          items={locationMaster.map((location) => ({
            key: location.value,
            value: location.key,
          }))}
          disabled
          value={values.location ?? ""}
        /> */}
        <MFTextField
          name={`location`}
          label={'Location'}
          placeholder="Enter Location"
          disabled
          value={values.location ?? ""}
        />
      </GridItem>
      {!rmsList.length && isSupportRM && (
        <GridItem>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
              height: '100%',
              width: '100%',
              mt: 10,
            }}>
            <Typography
              sx={{
                fontSize: 18,
                fontWeight: 500,
                color: 'rgb(97, 209, 214)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mb: '7%',
              }}>
              {`AMC's RM is Not Available`}
            </Typography>
          </Box>
        </GridItem>
      )}
      {isSupportRM && rmsList?.length > 0 && (
        <>
          <GridItem>
            <SearchableSelect
              name="rm_id"
              label="RM's Name*"
              items={rmsListSorting.sort().map((item: SupportRmProp) => ({
                key: item.name,
                value: item.id,
              }))}
              searchFieldPlaceholder={'Search RM'}
            />
          </GridItem>
          {values.rm_id && (
            <>
              <GridItem>
                <MFTextField
                  name="amcEmail"
                  label="RM's Email ID"
                  placeholder="Enter RM's Email ID"
                  value={selectedRm?.user?.email}
                  disabled={true}
                />
              </GridItem>
              <GridItem>
                <MFTextField
                  name="amcMobile"
                  label="RM's Mobile Number"
                  placeholder="Enter RM's Mobile Number"
                  value={selectedRm?.user?.phone}
                  disabled={true}
                />
              </GridItem>
              <GridItem>
                <MFSelectField
                  name={`amcLocation`}
                  label="Location"
                  items={locationMaster.map((location) => ({
                    key: location.value,
                    value: location.key,
                  }))}
                  value={selectedRm?.location}
                  disabled={true}
                />
              </GridItem>
            </>
          )}
        </>
      )}
    </>
  );
};

export default function DistributorDetails(): JSX.Element {
  const dispatch = useDispatch();
  const history = useHistory();
  const { path: currentPath } = useRouteMatch();
  const { application } = useSelector((store: RootStateType) => store.application);
  const { role, userDetails } = useSelector((store: RootStateType) => store.auth);
  const { rm, rm_id, supportRm, support_rm_id } = application || {};
  const { auth } = useSelector((store: RootStateType) => store);
  const [open, setOpen] = useState<boolean>(false);
  const [message, setMessage] = useState<string>('');
  const [currentFlag, setCurrentFlag] = useState<string | null>(null);
  const [rmsDropdwn, setRmsDropdwn] = useState<Array<{ key: string; value: string | number }>>([]);

  const isDiyInvestorOnboarding = currentPath?.includes("/investor-onboarding-application");
  const flowTypeDiy = application?.onboardingFlowType ? application?.onboardingFlowType?.toLowerCase() === "diy" : false;

  const isSupportRM = isDiyInvestorOnboarding ? false : auth.id === application?.supportRm?.userId;
  const { onboardingVia } = application || {};

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [rmsLoading, setRmsLoading] = useState<boolean>(false);
  const [diyRmsListLoading, setDiyRmsListLoading] = useState<boolean>(false);
  const [diyRmList, setDiyRmList] = useState<Array<{ key: string; value: string | number }>>([]);


  // console.log('user', userDetails);

  const {
    user: { email: RMEmail = '', firstName: RMFirstName = '', phone, countryCode },
    branchName: RMLocation = '',
  } = (isSupportRM ? supportRm : rm) || { empCode: '', user: { email: '' } };

  const initialValues: DistributorDetailsProps = {
    email: isDiyInvestorOnboarding ? '' : RMEmail,
    firstName: isDiyInvestorOnboarding ? '' : RMFirstName,
    phone: isDiyInvestorOnboarding ? '' : countryCode ? countryCode + ' ' + phone : phone,
    saveType: 'save and proceed',
    rm_id,
    location: isDiyInvestorOnboarding ? '' : RMLocation,
    ...(PHYSICAL_DIGITAL_FLOW
      ?
      {
        // isBSEEnabled: flowTypeDiy ? true : application?.isBSEEnabled ?? true,
        // isEsignEnabled: flowTypeDiy ? true : application?.isEsignEnabled ?? onboardingVia === 'digital', 
        isBSEEnabled: application?.isBSEEnabled ?? true,
        isEsignEnabled: application?.isEsignEnabled ?? `${onboardingVia ?? ""}`.toLowerCase() === 'digital',
        currentRM: isDiyInvestorOnboarding ? application?.currentStep === null ? "" : diyRmList.find(rm => rm.value === application?.rm_id)?.value ?? '' : rmsDropdwn.find(rm => rm.value === application?.rm_id)?.value ?? ''
      }
      :
      {}
    )


    // currentRM: application?.rm_id ?? '',

  };

  const [rmsList, setRmList] = useState<RMType[]>([]);
  const [locationMaster, setLocationMaster] = useState<mdmsLocationList[]>([]);

  const getRmsData = async () => {
    setRmsLoading(true);

    const rmsListRes = (await dispatch(getRMByIwappRmId(userDetails?.iwappRmId)) as unknown as RMType[]);

    const rmsDropdownList = rmsListRes?.map(rm => ({
      key: rm.name ?? '',
      value: rm.id ?? ''
    }))

    setRmsDropdwn([
      {
        key: "Self",
        value: userDetails?.id ?? ""
      },
      ...rmsDropdownList
    ])
  }

  const getDiyRmListData = async () => {
    try {
      setDiyRmsListLoading(true);
      const diyRmListRes = await (dispatch(getRMsList()) as unknown as Promise<RMType[]>);
      const rmsDropdownList = diyRmListRes?.map(rm => ({
        key: `${rm.name}${rm?.branchName ? ` / ${rm.branchName}` : ''} `,
        value: rm.id ?? ''
      }))
      setDiyRmList(rmsDropdownList);
    } catch (e) {
      console.error('Error', e);
    } finally {
      setDiyRmsListLoading(false);
    }
  }

  useEffect(() => {
    (async function () {
      try {

        PHYSICAL_DIGITAL_FLOW && [USER_ROLES.RM, USER_ROLES.OPE].includes(role) && userDetails?.userRole !== "REX" && await getRmsData();
        [USER_ROLES.INVESTOR].includes(role) && getDiyRmListData();

        let updateRMList: RMType[] = [];
        const locations = (await dispatch(getLocationList())) as unknown as LocationType;
        setLocationMaster(locations.rmLocationList);
        if (isSupportRM) {
          const listedRM = ((await dispatch(getRMById(Number(support_rm_id)))) as unknown as RMType)
            ?.amcRmDetails;
          updateRMList =
            application?.rm_id &&
              // optional chaining: truthy rm_id does not guarantee application.rm is defined
              (!application.rm?.isActive || !listedRM?.amcRmIds.includes(`${application?.rm_id}`))
              ? [...(listedRM?.amcRms || []), application?.rm]
              : listedRM?.amcRms || [];
        }
        setRmList(updateRMList);
      } catch (e: unknown) {
        console.error((e as Error).message);
      }
      finally {
        setRmsLoading(false);
      }
    })();
  }, [application]);
  const onSubmit = async (values: DistributorDetailsProps) => {
    try {
      setIsLoading(true)

      if (!rmsList.length && isSupportRM) {
        throw `AMC's RM is Not Available`;
      }
      const { saveType } = values;
      const { id, applicant1ReferenceId, currentStep = null, status, hasPOA } = application || {};
      const checkApplication = applicationComparison(application, {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        ...application!,
        currentStep: currentStep === null ? 1 : currentStep,
        ...(PHYSICAL_DIGITAL_FLOW ? {
          rm_id: values.currentRM || application?.rm_id,
          isBSEEnabled: values.isBSEEnabled,
          isEsignEnabled: values.isEsignEnabled,
        } : {
          rm_id: values.rm_id
        }),
      });
      if (id && !checkApplication) {
        const response = await dispatch(
          updateApplication({
            body: {
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              ...application!,
              onboardingVia: values?.isEsignEnabled ? 'digital' : 'physical',
              status:
                !hasPOA &&
                  AMC_APPROVER_CHECK_FOR_INDIVIDUAL &&
                  status !== 'draft' &&
                  applyRoleBasedStatus(role)
                  ? 'sent_to_amc_approver'
                  : status,
              currentStep: 1,
              // rm_id: values.currentRM,
              ...(PHYSICAL_DIGITAL_FLOW ? {
                rm_id: isDiyInvestorOnboarding ? (values.currentRM || application?.rm_id) : userDetails?.userRole === ROLE_TYPE.REX ? rm_id : (values.currentRM || rm_id),
                isBSEEnabled: values.isBSEEnabled,
                isEsignEnabled: values.isEsignEnabled,
              } : {
                rm_id: values.rm_id,
              })
              //currentStep === null ? 1 : currentStep
              // filledBy,
            },
            applicationId: id,
          })
        );

        if (!response) return;

        saveType === 'save and proceed'
          ? history.push('personal-details', { id, applicant1ReferenceId })
          : history.push(saveForLater(role, id, applicant1ReferenceId));
      } else if (checkApplication) {
        saveType === 'save and proceed'
          ? history.push('personal-details', { id, applicant1ReferenceId })
          : history.push(saveForLater(role, id, applicant1ReferenceId));
      }
      saveType === 'save and proceed'
        ? history.push('personal-details', { id, applicant1ReferenceId })
        : history.push(saveForLater(role, id, applicant1ReferenceId));
    } catch (e) {
      typeof e === 'string' && dispatch(showError(e as string));
      console.error((e as Error).message);
    } finally {
      setIsLoading(false)
    }
  };

  const handleCheckboxCheck = (type: string, checked: boolean) => {
    setOpen(true)
    setCurrentFlag(type);
    if (type === 'bse') {
      setMessage(`Do you want to ${checked ? 'enable' : 'disable'} BSE?`)
    }
    else {
      setMessage(`Do you want to ${checked ? 'enable' : 'disable'} E-Sign?`)
    }
  }

  const handleDialogSave = (setValues: any, values: any) => {
    if (currentFlag === 'bse') {
      setValues({
        ...values,
        isBSEEnabled: !values.isBSEEnabled
      });
    } else if (currentFlag === 'esign') {
      setValues({
        ...values,
        isEsignEnabled: !values.isEsignEnabled
      });
    }
    setOpen(false);
  }


  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={distributorsValidationSchema(isSupportRM, rmsList, userDetails?.userRole, PHYSICAL_DIGITAL_FLOW, role)}
        onSubmit={onSubmit}
        enableReinitialize={true}>
        {({ handleSubmit, values, setValues, errors }) => {
          return (
            <>
              <Box component="form" noValidate onSubmit={handleSubmit}>
                <Grid container columnSpacing={3} rowSpacing={0.5}>

                  {(PHYSICAL_DIGITAL_FLOW && [USER_ROLES.RM, USER_ROLES.OPE].includes(role) && userDetails?.userRole !== "REX")
                    || (USER_ROLES.INVESTOR).includes(role) &&
                    (
                      <>
                        <Grid item xs={12} lg={6} >
                          <SearchableSelect
                            name={`currentRM`}
                            // label="Current RM"
                            label="Select RM"
                            items={isDiyInvestorOnboarding ? diyRmList : rmsDropdwn}
                            // items={nationalitiesMdmsResponse.map((nationality) => ({
                            //   key: nationality.name,
                            //   value: nationality.name,
                            // }))}
                            // disabled={isFieldDisabled}
                            searchFieldPlaceholder={'Search RM'}
                          />
                        </Grid>

                        <Grid item lg={6} sx={{ visibility: { xs: 'hidden', sm: 'visible' } }} />
                      </>
                    )
                  }

                  {!isDiyInvestorOnboarding &&
                    <>
                      <RMDetail
                        isSupportRM={isSupportRM}
                        rmsList={rmsList}
                        values={values}
                        locationMaster={locationMaster}
                      />

                      {PHYSICAL_DIGITAL_FLOW && (
                        <>
                          <Grid item xs={12}>
                            <Divider sx={{ color: 'red', mt: 2 }} />
                          </Grid>

                          <Grid item xs={12}>
                            <Typography variant='h2' mt={2}>Enable/Disable BSE and E-Sign</Typography>
                          </Grid>
                        </>
                      )}

                      {PHYSICAL_DIGITAL_FLOW && (
                        <Grid item container mt={3}>
                          <Grid item xs={12} sm={6} >
                            <MFCheckbox
                              name={`isBSEEnabled`}
                              label={`Is BSE Enabled`}
                              checked={values.isBSEEnabled}
                              sx={{ letterSpacing: '1px' }}
                              onChange={(e) => handleCheckboxCheck('bse', e.target.checked)}
                              // disabled={[USER_ROLES.AMCAPPROVER].includes(role) || flowTypeDiy}
                              disabled
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <MFCheckbox
                              name={`isEsignEnabled`}
                              label={`Is E-Sign Enabled`}
                              checked={values.isEsignEnabled}
                              sx={{ letterSpacing: '1px' }}
                              onChange={(e) => handleCheckboxCheck('esign', e.target.checked)}
                              // disabled={[USER_ROLES.AMCAPPROVER].includes(role) || flowTypeDiy}
                              disabled={[USER_ROLES.AMCAPPROVER].includes(role) || `${application?.applicationType ?? ""}`.toLowerCase() === "individual"}
                            />
                          </Grid>
                        </Grid>
                      )}
                    </>
                  }


                  <Grid item xs={12} my={1} />
                  <ProceedSaveLater
                    saveLater={() => {
                      setValues({
                        ...values,
                        saveType: 'save for later',
                      });
                    }}
                    saveAndProceed={() => {
                      setValues({
                        ...values,
                        saveType: 'save and proceed',
                      });
                    }}
                    loader={isLoading}
                    clickedButton={values.saveType}
                    saveButtonText="Continue"
                    showEndIcon={false}
                  />
                </Grid>
              </Box>
              <Dialog
                onClose={setOpen}
                open={open}
                maxWidth='sm'
                fullWidth
                sx={{
                  '& .MuiPaper-root': {
                    borderRadius: '15px',
                    backgroundColor: "background.paper",
                    rowGap: "25px",
                  },
                }}
              >
                <DialogContent sx={{ paddingTop: "25px" }}>
                  <Box sx={{ display: "flex", columnGap: "8px" }}>
                    {/* {showIcon ? icon || <WarningIcon /> : null} */}
                    <Typography variant='h2' color="text.primary" mb="10px">{message}</Typography>
                  </Box>
                </DialogContent>
                <DialogActions sx={{ padding: "25px", columnGap: "10px" }}>
                  <Button
                    variant="outlined"
                    onClick={() => setOpen(false)}
                    sx={(theme: Theme) => ({
                      color: theme.palette.text.secondary,
                      flex: 1,
                      border: `0.5px solid ${theme.palette.text.secondary}`,
                      padding: "10px",
                      "&:hover, &.Mui-focusVisible": {
                        borderColor: theme.palette.text.secondary,
                        backgroundColor: theme.palette.background.default
                      }
                    })}
                  >
                    {'No'}
                  </Button>
                  <Button
                    variant="contained"
                    sx={(theme: Theme) => ({
                      flex: 1,
                      color: theme.palette.textDark.primary,
                      padding: "10px"
                    })}
                    onClick={() => handleDialogSave(setValues, values)}
                  >
                    {'Yes'}
                  </Button>
                </DialogActions>
              </Dialog>
            </>
          )
        }
        }
      </Formik>
    </>
  );
}
